import { render, staticRenderFns } from "./TopNdviAreaHeader.vue?vue&type=template&id=108b9caa&scoped=true&"
import script from "./TopNdviAreaHeader.vue?vue&type=script&lang=js&"
export * from "./TopNdviAreaHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108b9caa",
  null
  
)

export default component.exports